module.exports = __webpack_public_path__ + "img/agreement_cover.7c1be034.png";